/**
 * Extracted logic for stopping a fullscreen recording session.
 *
 * Called when the user taps STOP in the fullscreen recording dock.
 * Exits fullscreen immediately (waveform fades out over ~400ms),
 * then opens the conversation after a short delay so the user sees
 * a smooth staged transition instead of an instant swap.
 */

/** Delay (ms) before opening the conversation — lets the waveform
 *  fade out partway so the transition feels intentional, not jarring. */
export const CONVERSATION_OPEN_DELAY_MS = 300;

export type StopFromFullscreenDeps = {
  exitFullscreen: () => void;
  setIsConversationOpen: (v: boolean) => void;
  setKeepWelcomeMounted: (v: boolean) => void;
  requestScrollToBottom: () => void;
  ctaStop: () => void;
};

export function stopFromFullscreen(deps: StopFromFullscreenDeps): void {
  deps.setKeepWelcomeMounted(true);
  deps.exitFullscreen();
  deps.ctaStop();

  // Open conversation after the waveform has mostly faded out,
  // creating a smooth staged transition instead of an instant swap.
  setTimeout(() => {
    deps.setIsConversationOpen(true);
    deps.requestScrollToBottom();
  }, CONVERSATION_OPEN_DELAY_MS);
}
